import { isFunction } from 'lodash';
import { parseExperiments } from 'wix-rich-content-common/libs/experiments';
export function experimentStrategy(wixExperiments) {
    const features = {
        ricosFeatures: {},
        wixRicosFeatures: {},
    };
    if (!wixExperiments) {
        return features;
    }
    const unboxed = isFunction(wixExperiments === null || wixExperiments === void 0 ? void 0 : wixExperiments.all) ? wixExperiments.all() : wixExperiments;
    const experiments = parseExperiments(unboxed);
    return Object.entries(experiments).reduce((featureList, [name, experiment]) => {
        if ((experiment === null || experiment === void 0 ? void 0 : experiment.namespace) === 'wixRicos') {
            featureList.wixRicosFeatures[name] = experiment;
        }
        else if ((experiment === null || experiment === void 0 ? void 0 : experiment.namespace) === 'ricos') {
            featureList.ricosFeatures[name] = experiment;
        }
        return featureList;
    }, features);
}
//# sourceMappingURL=experimentStrategy.js.map